<div class="row row-mobile g-2 gx-md-5 footer-border px-4" [ngClass]="themeClass('topfooter-section1')">
    <div class="col-md-4 col-lg-2 footer-column-shop-by footer-data">
        <h6 class="footer-heading custom-ps-2">{{footerdata?.links?.columns_1?.[0]?.menu_name}}</h6>
        <ul class="list-unstyled">
            <li *ngFor="let footer of footerdata?.links?.columns_1.slice(1)">
                <a (click)="onClick($event, footer?.menu_link,footer?.menu_name)" class="cursor-pointer">{{footer?.menu_name}}</a>
            </li>
        </ul>
    </div>
    <div class="col-md-4 col-lg-2 footer-data heri-list" [ngClass]="themeClass('topfooter-section2')">
        <h6 class="footer-heading">{{footerdata?.links?.columns_2?.[0]?.menu_name}}</h6>
        <ul class="list-unstyled">
            <li *ngFor="let footer of footerdata?.links?.columns_2.slice(1)">
                <a (click)="onClick($event, footer?.menu_link,footer?.menu_name)" class="cursor-pointer">{{footer?.menu_name}}</a>
            </li>
        </ul>
    </div>
    <ng-container>
        <div class="col-md-4 col-lg-3 my-account-garage footer-data">
            <h6 class="footer-heading">{{footerdata?.links?.columns_3?.[0]?.menu_name}}</h6>
            <ul class="list-unstyled">
                <li><a class="mb-0  footer-account cursor-pointer"
                        (click)="onClick($event, footerdata?.links?.columns_3?.[1]?.menu_link,footerdata?.links?.columns_3?.[1]?.menu_name)">{{footerdata?.links?.columns_3?.[1]?.menu_name}}</a>
                </li>
                <li *ngFor="let footer of footerdata?.links?.columns_3.slice(2); let i = index">
                    <a class="cursor-pointer" (click)="onClick($event, footer?.menu_link ,footer?.menu_name)">
                        {{ footer?.menu_name }}
                    </a>
                </li>
            </ul>
        </div>
    </ng-container>
    <ng-container>
        <div class="col-md-4 col-lg-2 footer-data pe-0 d-md-block">
            <h6 class="footer-heading cursor-pointer"
                (click)="onClick($event, footerdata?.links?.columns_4?.[0]?.menu_link,footerdata?.links?.columns_4?.[0]?.menu_name)">
                {{footerdata?.links?.columns_4?.[0]?.menu_name}}</h6>
            <ul class="list-unstyled">
                <li *ngFor="let footer of footerdata?.links?.columns_4.slice(1)"><a class="cursor-pointer" [ngClass]="{'top-padding': footer.menu_name === 'Become a Dealer' || footer.menu_name === 'Find a Dealer'}"
                        (click)="onClick($event, footer.menu_link,footer?.menu_name)">{{ footer.menu_name }} </a>
                </li>
            </ul>
        </div>
    </ng-container>
    <ng-container *ngIf="showContactDetails">
        <div class="col-md-4 col-lg-3 social-info footer-data">
            <div [ngClass]="themeClass('topfooter-section3')">
            <img [src]="cdnImagePath + footerdata?.footerLogo?.[0]?.footer_logo"
                class="pb-4 footer-custum-logo img-fluid cursor-pointer" alt="footer-logo"  [routerLink]="['/']" (click)="scrollTop()">
                </div>
            <div [innerHTML]="footerdata?.contactDetails?.[0]?.company_info"></div>
            <ul class="list-unstyled">
                <li class=" d-flex gap-custom-footer">
                    <span *ngFor="let icon of footerdata?.socialIconsCopyright.slice(0,4)">
                        <a *ngIf="isExternal(icon?.menu_link)" class="social-icon" [href]="icon?.menu_link"
                            target="_blank" rel="noopener noreferrer">
                            <img *ngIf="icon?.link_style == 'Circle'" [src]="cdnImagePath + icon?.icon_image"
                                [alt]="icon?.menu_name">
                        </a>
                    </span>
                </li>
            </ul>
        </div>
    </ng-container>
</div>